import { FeaturedAuction } from '../components/deprecated/DayAuction/FeaturedAuctions';

export const MockAuction = (locale: string, id: number): FeaturedAuction => ({
  id,
  href: `https://www.catawiki.com/${locale}/a/${id}-auction`,
  title: `Auction id - ${id}`,
  curator: {
    id: 0,
    name: 'Curator name',
    image_large: null,
    image_small: null,
    profile_complete: true,
  },
  mainImage: '',
  thumbImages: ['', '', ''],
  numberOfLots: 103,
  closeAt: new Date(Date.now() + 86_400_000).getTime(),
});
